export default __webpack_public_path__ + "static/03.06-5f95f39714326118a135c12f755cbf6a.png";